import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InputHookForm from '../../ui/InputHookForm';
import SelectHookForm from '../../ui/selects/SelectHookForm';
import { countryOptions, timeZoneOptions } from './formOptions';
import { useFormContext } from 'react-hook-form';
import PhoneInputHookForm from '../../ui/PhoneInputHookForm';
import { isValidPhoneNumber } from 'react-phone-number-input';

export const FormGroup = styled.div`
  align-items: center;
  display: grid;
  grid-gap: 16px;
  grid-template-columns: ${({ half }) => (half ? '1fr 1fr' : '1fr')};
  padding-bottom: 16px;
`;

const BookForm = ({ client, isLoading }) => {
  const { watch, setValue } = useFormContext();

  const phone = watch('phone', undefined);

  const onFocusPhoneInput = event => {
    if (!phone) {
      setValue('phone', client.phone || '+1');
      // move cursor to end of input - https://stackoverflow.com/questions/44983286/
      event.currentTarget.setSelectionRange(
        event.currentTarget.value?.length,
        event.currentTarget.value?.length,
      );
    }
  };

  return (
    <>
      <FormGroup>
        <InputHookForm
          ariaLabel="Company"
          name="company"
          defaultValue={client.company}
          isDisabled={isLoading}
          autoComplete="organization"
          label="Company Name"
          rules={{ required: { value: true, message: 'Company name is required' } }}
        />
      </FormGroup>
      <FormGroup>
        <PhoneInputHookForm
          ariaLabel="Phone Number"
          name="phone"
          defaultValue={client.phone}
          isDisabled={isLoading}
          autoComplete="tel"
          placeholder="+1 750 555 5555"
          onFocus={onFocusPhoneInput}
          label="Phone Number"
          rules={{
            required: { value: true, message: 'Phone number is required' },
            validate: {
              isValid: phoneNumber =>
                isValidPhoneNumber(phoneNumber) || 'Please enter a valid phone number',
            },
          }}
        />
      </FormGroup>
      <FormGroup half>
        <SelectHookForm
          name="countryCode"
          ariaLabel="Country"
          isSearchable={false}
          defaultValue={client.countryCode || 'US'}
          isDisabled={isLoading}
          options={countryOptions}
          rules={{ required: { value: true, message: 'Country is required' } }}
          label="Country"
        />
        <SelectHookForm
          name="timeZone"
          ariaLabel="Time Zone"
          isDisabled={isLoading}
          defaultValue={client.timeZone}
          options={timeZoneOptions}
          rules={{
            required: { value: true, message: 'Time zone is required' },
          }}
          label="Time Zone"
        />
      </FormGroup>
    </>
  );
};

BookForm.propTypes = {
  isLoading: PropTypes.bool,
  client: PropTypes.object.isRequired,
};

BookForm.defaultProps = {
  isLoading: false,
};

export default BookForm;
